module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SCROSS-1.8a6deb8a.jpg";